import { Pines, Horarios } from '../../../domain/models/Pines';

export interface PinesUsuariostateInterface {
    pinesUsuarios: Pines[];
    pinesHorarios: Horarios
}
export class PinesState implements PinesUsuariostateInterface {
    pinesUsuarios: Pines[];
    pinesHorarios: Horarios;
    constructor({
        pinesUsuarios = [],
        pinesHorarios = new Horarios({})
    }: PinesUsuariostateInterface) {
        this.pinesUsuarios = pinesUsuarios;
        this.pinesHorarios = pinesHorarios;
    }
}